import OktaAuth from '@okta/okta-auth-js'
import axios from 'axios'
import { processErrorMsg } from 'utils'

export const issuer = `https://${process.env.REACT_APP_OKTA_DOMAIN}/oauth2/default`

/**
 * Ref: https://github.com/okta/okta-auth-js#required-options
 */
export const oidcConfig: any = {
  /**
   * The URL for your Okta organization or an Okta authentication server
   */
  issuer,

  /**
   * Uniquely identifies your Okta application.
   */
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,

  /**
   * It handles token parsing, token storage, and redirecting to a protected
   * page if one triggered the login.
   * This must be listed in your Okta application's Login redirect URIs.
   */
  redirectUri: window.location.origin + '/implicit/callback',

  /**
   * Enable the PKCE OAuth Flow. Default value is true. If set to false,
   * the authorization flow will use the Implicit OAuth Flow.
   * Ref:
   * - Authorization Code Flow with PKCE: https://developer.okta.com/docs/concepts/auth-overview/#authorization-code-flow-with-pkce
   * - Implicit Flow: https://developer.okta.com/docs/concepts/auth-overview/#implicit-flow
   */
  pkce: Boolean(OktaAuth?.features?.isPKCESupported()),

  /**
   * The scopes associated with access tokens determine which claims are
   * available when they are used to access the OIDC /userinfo endpoint.
   * Ref: https://developer.okta.com/docs/reference/api/oidc/#scopes
   */
  scopes: ['openid', 'email', 'profile', 'groups', 'phone'],
}

export const oidcImpersonateGatewayConfig: any = {
  issuer,
  clientId: process.env.REACT_APP_IMPERSONATE_GATEWAY_CLIENT_ID,
  redirectUri: window.location.origin + '/gateway/callback',
}

export const getAuthClient = (config = {} as any): any =>
  new OktaAuth({
    issuer: oidcConfig.issuer,
    scopes: oidcConfig.scopes,
    ...config,
  })

export const isOktaDown = async () => {
  try {
    const response = await axios.get(
      `${issuer}/.well-known/oauth-authorization-server`,
    )
    return response.status !== 200
  } catch (e) {
    processErrorMsg(
      {
        customMessage: 'Okta is down!',
        error: e,
      },
      'Okta Health Check',
    )
    return true
  }
}
